/**
 * ZILURA scroll lock: stops the page behind the menu drawer, cart drawer, search and quick-view from scrolling.
 * Sense only puts overflow:hidden on <body> (overflow-hidden / overflow-hidden-{mobile,tablet,desktop}),
 * which phones ignore for touch scrolling. While any of those classes is active this adds
 * html.zl-scroll-locked (overflow hidden on html, see assets/zilura-extras.css) and blocks touch moves
 * that would not scroll something inside the open panel.
 */
(function () {
  if (window.zlScrollLock) return;

  const html = document.documentElement;
  const body = document.body;
  const tablet = window.matchMedia('(max-width: 989px)');
  const mobile = window.matchMedia('(max-width: 749px)');
  let locked = false;

  const wantsLock = () => {
    const c = body.classList;
    return (
      c.contains('overflow-hidden') ||
      c.contains('overflow-hidden-desktop') ||
      (c.contains('overflow-hidden-tablet') && tablet.matches) ||
      (c.contains('overflow-hidden-mobile') && mobile.matches)
    );
  };

  const canScroll = (el, s) =>
    (/(auto|scroll)/.test(s.overflowY) && el.scrollHeight > el.clientHeight + 1) ||
    (/(auto|scroll)/.test(s.overflowX) && el.scrollWidth > el.clientWidth + 1);

  const onTouchMove = (event) => {
    if (event.touches && event.touches.length > 1) return;
    for (let el = event.target; el && el !== body && el !== html; el = el.parentElement) {
      if (el.nodeType === 1 && canScroll(el, window.getComputedStyle(el))) return;
    }
    if (event.cancelable) event.preventDefault();
  };

  const update = () => {
    const want = wantsLock();
    if (want === locked) return;
    locked = want;
    html.classList.toggle('zl-scroll-locked', want);
    if (want) document.addEventListener('touchmove', onTouchMove, { passive: false });
    else document.removeEventListener('touchmove', onTouchMove);
  };

  new MutationObserver(update).observe(body, { attributes: true, attributeFilter: ['class'] });
  tablet.addEventListener('change', update);
  mobile.addEventListener('change', update);
  update();

  window.zlScrollLock = { update };
})();
